"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftingFlow = void 0;

var _SelectCampaign = require("./modules/SelectCampaign");

var _CreateContacts = require("./modules/CreateContacts");

var _Messaging = require("./modules/Messaging");

var _SelectProduct = require("./modules/SelectProduct");

var _SendingBatch = require("./modules/SendingBatch");

var _Success = require("./modules/Success");

var _components = require("./components");

var _providers = require("./providers");

var _giftingFlow = require("./store/giftingFlow.actions");

var _hooks = require("./hooks");

var _giftingFlow2 = require("./store/giftingFlow.reducer");

var _activeStep = require("./store/ui/activeStep/activeStep.constants");

var _BatchEmailPreview = require("./modules/BatchEmailPreview");

var _createBatchStep = require("./store/ui/createBatchStep");

var GiftingFlow = {
  GiftingFlowProvider: _providers.GiftingFlowProvider,
  SelectCampaign: _SelectCampaign.SelectCampaign,
  CreateContacts: _CreateContacts.CreateContacts,
  Messaging: _Messaging.Messaging,
  GiftingFlowStep: _activeStep.GiftingFlowStep,
  SelectProduct: _SelectProduct.SelectProduct,
  SendingBatch: _SendingBatch.SendingBatch,
  Success: _Success.Success,
  Stepper: _components.Stepper,
  StepperContainer: _components.StepperContainer,
  StepTitle: _components.StepTitle,
  StepperFooter: _components.StepperFooter,
  StepperFooterContainer: _components.StepperFooterContainer,
  BatchEmailPreview: _BatchEmailPreview.BatchEmailPreview,
  actions: {
    resetGiftingFlowState: _giftingFlow.resetGiftingFlowState
  },
  reducer: _giftingFlow2.giftingFlow,
  name: 'giftingFlow',
  hooks: {
    useGiftingFlowSteps: _hooks.useGiftingFlowSteps,
    useActiveStep: _hooks.useActiveStep,
    useGiftingFlowContext: _providers.useGiftingFlowContext
  },
  selectors: {
    getIsCreateBatchStepContactsPreview: _createBatchStep.getIsCreateBatchStepContactsPreview
  }
};
exports.GiftingFlow = GiftingFlow;